/**
 * ADD IT — the phone's bottom sheet (docs/ADD-IT.md, spec 2026-09-04; the
 * CALL IT frame, `design/GT Mobile Mine.dc.html:409-430`, with two rows in
 * place of the strip).
 *
 * Discover's `+` asks where the game goes: `GAMES TONIGHT?` (the party's list)
 * or `MY BACKLOG` (yours alone). Two separate bordered cells, NOT a joined
 * segmented pair — they are two different actions. A row the game is already
 * on is a fact, not a button. Choosing closes the sheet first, then adds.
 *
 * Built ahead of the mirror (Marcus, 2026-09-04) — when the design agent draws
 * theirs, this file follows the pulled bytes.
 */

import { DoorIcon } from '../components/DoorIcon.tsx';
import { Sheet } from '../components/Sheet.tsx';
import { useQd } from '../store/index.ts';
import { addItVM } from '../store/selectors.ts';

const MONO = 'var(--gt-font-mono)';
const PIXEL = 'var(--gt-font-pixel)';

export default function AddItSheet(): JSX.Element {
  const s = useQd();
  const v = addItVM(s);
  return (
    <Sheet onClose={() => s.closeAdd()} label="Add it sheet" zIndex={85} header={{ title: 'ADD IT', titleClr: 'var(--gt-text)', titleFs: '9.5px' }}>
      <div style={{ padding: '14px 14px 4px', display: 'flex', flexDirection: 'column', gap: 5 }}>
        <span style={{ fontFamily: 'var(--gt-font-sans)', fontWeight: 600, fontSize: 15, color: 'var(--gt-text)' }}>{v.n}</span>
        <span style={{ fontFamily: MONO, fontSize: 8.5, letterSpacing: '.07em', color: 'var(--gt-faint)' }}>{v.strap}</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '10px 14px', paddingBottom: 'calc(20px + env(safe-area-inset-bottom))' }}>
        {v.rows.map((r) => (
          <div
            key={r.key}
            onClick={() => {
              if (r.done) return;
              void (r.key === 'tonight' ? s.addToTonight() : s.addToBacklog());
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              height: 64,
              padding: '0 13px',
              border: '1px solid ' + (r.done ? 'var(--acc)' : 'var(--gt-border-2)'),
              background: r.done ? 'var(--accSoft)' : 'transparent',
              cursor: r.done ? 'default' : 'pointer',
              boxSizing: 'border-box',
            }}
          >
            <DoorIcon kind={r.icon} size={16} />
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
              <span style={{ fontFamily: PIXEL, fontSize: 8.5, color: r.done ? 'var(--acc)' : 'var(--gt-text)', display: 'flex', alignItems: 'center' }}>
                <span style={{ transform: 'translateY(0.13em)' }}>{r.l}</span>
              </span>
              <span style={{ fontFamily: MONO, fontSize: 8, letterSpacing: '.07em', color: 'var(--gt-muted)' }}>{r.gloss}</span>
            </div>
            <span style={{ fontFamily: MONO, fontSize: 9.5, letterSpacing: '.06em', color: r.done ? 'var(--acc)' : 'var(--gt-text)', whiteSpace: 'nowrap', flex: 'none' }}>
              {r.state}
            </span>
          </div>
        ))}
      </div>
    </Sheet>
  );
}
